    <div class="d-flex justify-content-start" style="height: 50px;  border-radius: 10px; border: 1px solid {{color}}; ">
        <div class="" style="height: 50px; width: 10px; background-color: {{color}};border-radius: 10px 0px 0px 10px; "></div>

        <div class="p-2 d-flex justify-content-start">
           <div class="align-self-center">
            <span style="text-align: left;">Mathématique</span>
            <br>
            <span style="text-align: left;">Carine .</span>
           </div>
          
        </div>
    
    </div>
